import React, { Component } from 'react'
import * as actions from "../actions";
import * as utils from "../../utils";

import DeleteItemLink from "../../common/components/delete-item-link";
import EditReplyLink from "./edit-reply-link";

const FeedReplyMenu = React.createClass({
  shouldComponentUpdate(nextProps, nextState) {
    return this.state.menuActive || nextState.menuActive;
  },
  getInitialState() {
    return { menuActive: false }
  },
  componentDidUpdate() {
    // Attach/remove an outside click event depending on whether the modal is open
    if (this.state.menuActive) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  },
  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  },
  render() {
    const { userId, comment, mentions, postId, replyId } = this.props;
    const cssClass = this.state.menuActive ? "active" : "";
    return (
      <div className={`feed-post-menu ${cssClass}`} onClick={this.handleMenuClick}>
        <i className="icon-arrow" />
        <ul>
          { utils.canEditEventItem(userId) &&
            <li>
              <EditReplyLink
                comment={comment}
                replyId={replyId}
                postId={postId}
                mentions={mentions}
              />
            </li>
          }
          <li>
            <DeleteItemLink
              onConfirmClick={this.handleDeleteClick}
              heading="Remove Reply"
              body="Are you sure you would like to remove this reply?"
              linkText="Remove"
              hideIcon="true"
            />
          </li>
        </ul>
      </div>
    );
  },
  handleMenuClick(e) {
    e.preventDefault();
    this.setState({menuActive: !this.state.menuActive});
  },
  handleOutsideClick(e) {
    e.preventDefault();
    this.setState({menuActive: false});
  },
  handleDeleteClick() {
    const { postId, replyId } = this.props;
    actions.deleteReply(replyId, postId);
  }
});

export default FeedReplyMenu;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/feed-reply-menu.es6